module.exports = "https://web-assets.ifttt.com/packs/media/docs/trigger_fields_all-c3426359.png";